import { Product } from 'schema-dts';
import { requireFromStaticAsset } from '../../client/utils/assetsUtils';

export function getEvaluationStructuredData(
  locality?: string,
): Product {
  const name = locality
    ? `Servizio di valutazione immobile a ${locality}`
    : 'Servizio di valutazione immobile';

  const description = locality
    ? [
      `Il calcolatore online per la valutazione degli immobili a ${locality} permette di calcolare il valore delle case in pochi minuti in base alle quotazioni immobiliari e all'andamento del mercato.`,
    ]
    : [
      "Il calcolatore online per la valutazione degli immobili permette di calcolare il valore delle case in pochi minuti in base alle quotazioni immobiliari e all'andamento del mercato.",
    ];
  return {
    '@type': 'Product',
    name,
    image: [
      requireFromStaticAsset('default-preview-social.png'),
    ],
    description,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      ratingCount: 1694,
    },
    brand: {
      '@type': 'Brand',
      name: 'Dove.it',
    },
  };
}
